import React from "react";
import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum";

type BannerProps = {
  app: string;
  program: string;
  title: string;
  userAuthType: USER_AUTH_TYPE;
  support: string;
};

const gradientMapper = {
  [USER_AUTH_TYPE.COMARCH_CUSTOMER]: "bg-[#0042c3]",
  [USER_AUTH_TYPE.COMARCH_EMPLOYEE]: "bg-[#0042c3]",
};
export default function Banner({
  app,
  program,
  title,
  userAuthType,
  support,
}: BannerProps) {
  return (
    <div className={`px-6 py-12 ${gradientMapper[userAuthType]}`}>
      <div className="container mx-auto flex flex-col justify-center items-center text-center">
        <h2 className="text-white sm:text-4xl text-3xl font-bold mb-6">
          {title}
        </h2>
      </div>
      {app === "Invite Portal" && (
        <>
          <div className="text-white text-3sm font-bold mb-6">
            {/* <h3 className="font-bold">
              Invite Your Practice To Join The {program}.
            </h3> */}
            {/*{program === "Practice Builder" ? (*/}
            {/*  <>*/}
                <p className="my-2">
                  Use this form to invite your practice to participate in the{" "}
                  {program}.
                </p>
                <p className="my-2">
                  As we revamp the new {program} experience, we need your
                  feedback if ECP account information is accurate
                </p>
              {/*</>*/}
            {/*) : (*/}
            {/*  <p className="my-2">*/}
            {/*    You're invited to join our New Partner Rewards Hub*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </>
      )}
      {app === "Registration Portal" && (
        <>
          <div className="text-white text-3sm font-bold mb-6">
            <h3 className="font-bold">
              You're Invited To Join Our New {program} Experience
            </h3>
            <p className="my-2">
              We’ve re imagined the {program} experience to make it easier than
              ever to manage your rewards and grow your practice.
            </p>
          </div>
        </>
      )}
    </div>
  );
}
